module.exports = __webpack_public_path__ + "static/media/19ESCAP35.ba946b2f.jpg";